import { ResellerLevel } from '@/interfaces/IResellerLevels';

export const RESELLER_LEVELS: ResellerLevel[] = [
	{
		level: 'Lite',
		min: 1,
		max: 19,
		features: ['Dedicated CSM', 'Priority Support'],
	},
	{
		level: 'Bronze',
		min: 20,
		max: 49,
		features: [
			'Private Slack Channel',
			'Weekly Call with WL Program Director',
			'Priority Integration Request',
		],
	},
	{
		level: 'Silver',
		min: 50,
		max: 99,
		features: ['Priority Feature Request', 'Lower Per Receptionist Price'],
	},
	{
		level: 'Gold',
		min: 100,
		max: 149,
		features: ['Beta Access to New Integrations', 'First 20% Access to New Features'],
	},
	{
		level: 'Platinum',
		min: 150,
		max: Infinity,
		features: ['Monthly Founder Calls', 'Lower Per Minute Rates'],
	},
];

export const CALCULATOR_DEFAULTS = {
	DEFAULT_SEAT_PRICE: 275,
	DEFAULT_SEATS: 30,
	MIN_SEAT_PRICE: 55,
	MAX_SEATS: 300,
	MIN_SEATS: 1,
} as const;

export const PROFIT_EXAMPLES = [
	{ seats: 10, label: '10 Seats' },
	{ seats: 25, label: '25 Seats' },
	{ seats: 50, label: '50 Seats' },
	{ seats: 100, label: '100 Seats' },
	{ seats: 150, label: '150 Seats' },
	{ seats: 200, label: '200 Seats' },
	{ seats: 250, label: '250 Seats' },
	{ seats: 300, label: '300 Seats' },
] as const;

export const SLIDER_MILESTONES = [1, 50, 100, 150, 200, 250, 300] as const;
